import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import {
  AppBar, Toolbar, Typography, Box, IconButton, Menu, MenuItem,
  Popper, ClickAwayListener, useTheme
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import axios from "axios";

const Navbars = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [searchPopperAnchorEl, setSearchPopperAnchorEl] = useState(null);
  const [adminImage, setAdminImage] = useState(null);
  const searchPopperRef = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      console.warn("No auth token found");
      return;
    }

    axios.get(
      'https://backend.maamaas.com/food/api/super-admin-profile/1',
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )
      .then((res) => {
        if (res.data && res.data.adminImage) {
          setAdminImage(res.data.adminImage);
        }
      })
      .catch((err) => console.error("Error fetching admin profile:", err));
  }, []);

  const handleProfileMenuOpen = (event) => {
    // Close search popper if open (to avoid overlap)
    handleSearchPopperClose();
    setMenuAnchorEl(event.currentTarget);
  };

  const handleProfileMenuClose = () => setMenuAnchorEl(null);

  const handleSearchPopperToggle = (event) => {
    setSearchPopperAnchorEl(searchPopperAnchorEl ? null : event.currentTarget);
  };

  const handleSearchPopperClose = () => setSearchPopperAnchorEl(null);

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("vendorId");
    handleProfileMenuClose();
    navigate("/");
  };

  const openSearchPopper = Boolean(searchPopperAnchorEl);
  const searchPopperId = openSearchPopper ? 'mobile-search-popper' : undefined;

  return (
    <AppBar position="fixed" elevation={0} sx={{ background: "#B15DC6", zIndex: 1200 }}>
      <Toolbar sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingX: { xs: 1, sm: 2 } }}>
        {/* Left Side: Logo */}
        <Box display="flex" alignItems="center">
          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
              color: "#fff",
              fontSize: { xs: "18px", sm: "24px", md: "31px" },
              whiteSpace: 'nowrap'
            }}
          >
            MAAMAA'S
          </Typography>
        </Box>

        {/* Right Side: Icons */}
        <Box display="flex" alignItems="center" gap={{ xs: 0.1, sm: 0.5, md: 1 }}>
          {/* Search Icon for Mobile */}


          {/* Admin Profile Image */}
          <IconButton
            onClick={handleProfileMenuOpen}
            size="large"
            sx={{ padding: 0 }}
          >
            {adminImage ? (
              <img
                src={adminImage}
                alt="Admin"
                style={{ width: 36, height: 36, borderRadius: "50%" }}
                onError={(e) => e.target.src = "/default-avatar.png"}
              />
            ) : (
              <Box
                sx={{
                  width: 36,
                  height: 36,
                  borderRadius: "50%",
                  backgroundColor: "#fff",
                  border: "2px solid #000",
                }}
              />
            )}
          </IconButton>
        </Box>

        {/* User Account Menu */}
        <Menu
          anchorEl={menuAnchorEl}
          open={Boolean(menuAnchorEl)}
          onClose={handleProfileMenuClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          slotProps={{
            paper: {
              sx: {
                marginTop: '8px',
                width: "130px",
                boxShadow: "0px 4px 12px rgba(0,0,0,0.15)",
                borderRadius: "8px",
                zIndex: 1500, // ensures it's above AppBar and Popper
              }
            }
          }}
        >
          <MenuItem onClick={handleLogout} sx={{ fontSize: { xs: '1rem', sm: '0.9rem' } }}>
            Logout
          </MenuItem>
        </Menu>

        {/* Mobile Search Popper */}

      </Toolbar>
    </AppBar>
  );
};

export default Navbars;
